<template>
    <div class="mPage">
        <swiper :options="outerSwiperOption" ref="outerSwiper" class="outerSwiper">
            <swiper-slide  class="container" >
                <m_home>
                    <img src="../img/m/m_menu.png" alt="" class="menu" @click="showNavBar()">  
                </m_home>
            </swiper-slide>
            <swiper-slide  class="container" >
                <m_news>
                     <img src="../img/m/m_menu.png" alt="" class="menu" @click="showNavBar()">  
                </m_news>
            </swiper-slide>
            <swiper-slide  class="container" >
                <m_timeline>
                     <img src="../img/m/m_menu.png" alt="" class="menu" @click="showNavBar()">  
                </m_timeline>
            </swiper-slide>
            <swiper-slide  class="container" >
                <m_speakers>
                     <img src="../img/m/m_menu.png" alt="" class="menu" @click="showNavBar()">  
                </m_speakers>
            </swiper-slide>
            <swiper-slide  class="container" >
                <m_award>
                     <img src="../img/m/m_menu.png" alt="" class="menu" @click="showNavBar()">  
                </m_award>
            </swiper-slide>
            <swiper-slide  class="container" >
                <m_picture>
                     <img src="../img/m/m_menu.png" alt="" class="menu" @click="showNavBar()">  
                </m_picture>
            </swiper-slide>
            <swiper-slide  class="container" >
                <m_resource>
                     <img src="../img/m/m_menu.png" alt="" class="menu" @click="showNavBar()">  
                </m_resource>
            </swiper-slide>
            <!-- <swiper-slide  class="container" >
                <m_history>
                     <img src="../img/m/m_menu.png" alt="" class="menu" @click="showNavBar()">  
                </m_history>
            </swiper-slide> -->
            
        </swiper>
        <mt-popup
        v-model="navbarShow" 
        position="right" class="secondPage">
            <m_navbar @close="close" @slideTo="slideTo"/>
        </mt-popup>
    </div>
</template>

<script>
import m_home from './m_home'
import m_news from './m_news'
import m_navbar from './m_navbar'
import m_timeline from './m_timeline'
import m_resource from './m_resource'
import m_award from './m_award'
//import m_history from './m_history'
import m_picture from './m_picture'
import m_speakers from './m_speakers'
export default {
    name: 'm_mainpage',
    components: {
        m_home,
        m_news,
        m_navbar,
        m_timeline,
        m_resource,
        m_award,
        //m_history,
        m_picture,
        m_speakers
    },
    data: function () {
        return {
            outerSwiperOption: {
                direction: 'vertical',
                noSwipingSelector: '.proFileInfo,.awardlist',
            },
            navbarShow: false
        }
    },
    computed: {
        outerSwiper() {
            return this.$refs.outerSwiper.swiper
        },
  },
    methods: {
        showNavBar () {
        this.navbarShow = true
        },
        close () {
            this.navbarShow = false
        },
        slideTo(index) {
            this['outerSwiper'].slideTo(index, 500, false)
            this.navbarShow = false
        }
    },
    mounted () {
        
        let sildeIndex = this.$route.query.to
        console.log(sildeIndex)
        this.slideTo(sildeIndex)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mPage {
    width: 100%;
    height: 100%;
    position: relative;
    .outerSwiper {
        width: 100%;
        height: 100%;
        background-image: url(../img/m/m_bg.png);
        background-size: cover;
        .container {
            width: 100%;
            height: 100%;
        }
    }
    .secondPage {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-image: url(../img/m/m_bg.png);
        background-size: cover;
    }
}
</style>
